import { alerts } from "@features/alerts/alerts"
import { useFerve } from "@features/ferve/FerveProvider"
import { FilmWishlistBasicsFragment } from "@generated-types"
import { proxy, ref, useSnapshot } from "valtio"
import { WishlistMultiSelectionProps } from "./WishlistSelectModal"
import { useAppData } from "eddev/hooks"
import { useFerveMode } from "@features/ferve/useFerveMode"

const modalsStore = proxy({
  modal: null as null | WishlistMultiSelectionProps,
})

export function useWishlistModals() {
  return {
    store: modalsStore,
    openModal(modal: WishlistMultiSelectionProps) {
      modalsStore.modal = modal
    },
  }
}

export function useWishlistEnabled() {
  const enableWatchlist = useAppData()?.sffSettings?.festivalSettings?.enableWatchlist
  const mode = useFerveMode()
  if (mode === "tff") return false
  return !!enableWatchlist
}

export function useWishlistToggle(film: string | number | FilmWishlistBasicsFragment) {
  if (env.admin) {
    return {
      active: false,
      toggle() {},
      working: false,
    }
  }
  const modals = useWishlistModals()
  const wishlist = useFerve().wishlist
  const state = useSnapshot(wishlist.state)

  if (typeof film === "string" || typeof film === "number") {
    const idHash = String(film)
    return {
      active: state.hashes.has(idHash),
      toggle() {
        if (state.hashes.has(idHash)) {
          wishlist.remove(idHash)
        } else {
          wishlist.add(idHash)
        }
      },
      working: false,
    }
  } else if (typeof film == "object" && film?.sessions?.length! > 0) {
    const hashes = film.sessions?.map((session) => String(session?.info?.ferveId)) ?? []
    const active = hashes.filter((hash) => state.hashes.has(hash))
    return {
      active: active.length > 0,
      toggle() {
        if (active.length > 0) {
          active.forEach((hash) => wishlist.remove(hash))
        } else {
          if (hashes.length > 1) {
            if (film.sessions?.length! > 1) {
              modals.openModal({
                sessions: !!film.sessions && ref(film.sessions as any),
              })
              return
            }
          } else {
            hashes.forEach((hash) => wishlist.add(hash))
          }
        }
      },
      working: false,
    }
  }
}
